import { EventEmitter } from '../EventEmitter'
import Spreadsheet from "./xspreadshee/xspreadsheet.js";
import './xspreadshee/xspreadsheet.css';
import { read, writeFileXLSX } from "xlsx";
import zhCN from './xspreadshee/locale/zh-cn.js';
Spreadsheet.locale('zh-cn', zhCN);
export default class Sheet extends EventEmitter {
    constructor(proc) {
        super(proc)
        this.proc = proc
    }

    loadType = {
        'LINK': 'link',
        'SCRIPT': 'script',
    }

    loaded = false;

    loadFile(urls = [], type) {
        let strake = [];
        let frag = document.createDocumentFragment()
        urls.forEach(url => {
            let link = new Promise((resolve, reject) => {
                let tag = null;
                if (type === this.loadType.LINK) {
                    tag = document.createElement('link')
                    tag.rel = 'stylesheet';
                    tag.href = url;
                } else if (type === this.loadType.SCRIPT) {
                    tag = document.createElement('script');
                    tag.src = url;
                    tag.type = 'text/javascript';
                }
                tag.onload = function () {
                    resolve(true)
                }
                tag.onerror = function (ERR) {
                    reject(ERR);
                };
                frag.appendChild(tag);
            })
            strake.push(link)

        })
        document.querySelector('head').appendChild(frag)

        Promise.all(strake).then(_ => {
            this.loaded = true;
            this.emit('SHEET-READR')
        }).catch(_ => {
            this.loaded = true;
        })
    }

    /**
     * 
     * @param {HTMLElement} container 
     * @returns {Promise<Spreadsheet>}
     */
    createSheet(container) {
        return new Promise((resolve) => {
            resolve(this.initSheet(container))

            if (this.loaded) {
                resolve(this.initSheet(container))

            } else {
                this.on('SHEET-READR', () => {
                    resolve(this.initSheet(container))
                })
            }
        })

    }

    initSheet(container) {
        // luckysheet.create({
        //     container: container
        // })

        let options = {
            view: {
                height: () => document.querySelector(container).clientHeight,
                width: () => document.querySelector(container).clientWidth,
            },
            
        }
        
        const s = new Spreadsheet(container, options)
           // load data
            .change(data => {
                console.log(data)
                // save data to db
            });

        // data validation
        s.validate()
        return s;
    }


}